import Script from '__core/shared/model/script/Script';
import stScriptsList from './scriptsList.component';
import scriptsController from './scripts.controller';
import stScriptEdit from './scriptEdit.component';

export default angular
  .module('st.Script', ['st.Core', 'angular-cache'])
  .factory('Script', () => Script)
  .component('stScriptsList', stScriptsList)
  .controller('scriptsController', scriptsController)
  .component('stScriptEdit', stScriptEdit)
  .service('scriptService', (Script, dataService) => ({
    createScript: (doc) => dataService.createDocument(Script, doc),
    readScript: (doc) => dataService.readDocument(Script, doc),
    updateScript: (doc) => dataService.updateDocument(Script, doc),
    deleteScript: (doc) => dataService.deleteDocument(Script, doc)
  }))
  .service('scriptsService', ($http, $rootScope, CacheFactory, dataService, Script, SCRIPT) => {
    let cache;
    if (!CacheFactory.get(SCRIPT.CACHE.NAME)) {
      cache = CacheFactory(SCRIPT.CACHE.NAME, SCRIPT.CACHE.STORE);
    }
    const cacheKey = (params, requestName) =>
      JSON.stringify({
        idAccount: $rootScope.CurrentAccount.id,
        idOrganization: $rootScope.CurrentOrganization.id,
        type: requestName || SCRIPT.CACHE.NAME,
        params
      });
    return {
      clearCache: () => cache.removeAll(),
      getAvailable: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params),
          params?.ignoreCache === true,
          Script.build,
          $http.get,
          SCRIPT.API.AVAILABLE,
          { params }
        )
    };
  })
  .constant('SCRIPT', {
    API: {
      AVAILABLE: '/api/v1/scripts/available/'
    },
    CACHE: {
      NAME: 'scriptsCache',
      STORE: {
        maxAge: 60 * 1000,
        deleteOnExpire: 'aggressive',
        recycleFreq: 30 * 1000,
        storageMode: 'sessionStorage'
      }
    }
  });
